import type { EBaseSetupGuideCampaign } from '~/modules/campaign/types';

export enum ESetupGuideCampaignTemplate {
  CHOOSE_TEMPLATE_TO_TEST = 'CHOOSE_TEMPLATE_TO_TEST',
  SETUP_TEST_VERSION = 'SETUP_TEST_VERSION',
  CHOOSE_TYPE_TO_TEST = 'CHOOSE_TYPE_TO_TEST',
}

export type ISetupGuideCampaignTemplate = ESetupGuideCampaignTemplate | EBaseSetupGuideCampaign;
